"use client";

import { useEffect, type RefObject } from "react";

const PICKER_TYPES = new Set(["date", "datetime-local", "time", "month", "week"]);

/**
 * iOS Safari's date picker "Reset" button restores the input's *default*
 * value (its `value` attribute), not an empty one. React keeps that attribute
 * in step with the controlled value, so Reset put back the date already
 * shown, fired no change, and the date could never be cleared. Blanking
 * `defaultValue` makes Reset clear the field and fire a normal change event.
 * The live `value` property is untouched.
 *
 * Runs after *every* render, not only when the value changes: React rewrites
 * the attribute on any re-render of a controlled input (e.g. `disabled`
 * toggling while saving, `min`/`max` moving), which silently re-broke Reset.
 */
export function useResettableDateInput(
  ref: RefObject<HTMLInputElement | null>,
  type: string | undefined
): void {
  useEffect(() => {
    const el = ref.current;
    if (!el || type === undefined || !PICKER_TYPES.has(type)) return;
    if (el.defaultValue !== "") el.defaultValue = "";
  });
}
